"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var empty_state_1 = tslib_1.__importDefault(require("../empty-state"));
var _1 = require(".");
var renderEmpty = function (componentName) { return (React.createElement(_1.ConfigConsumer, null, function (_a) {
    var getPrefixCls = _a.getPrefixCls;
    var prefix = getPrefixCls('empty');
    switch (componentName) {
        case 'Table':
        case 'List':
            return React.createElement(empty_state_1.default, null);
        case 'Select':
            return React.createElement(empty_state_1.default, null);
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
            return React.createElement(empty_state_1.default, { className: "".concat(prefix, "-small") });
        default:
            return React.createElement(empty_state_1.default, null);
    }
})); };
exports.default = renderEmpty;
//# sourceMappingURL=renderEmpty.js.map